import {Component} from '@angular/core';
import {MatDialogRef, MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {NgIf} from "@angular/common";
import {User} from "../../model/user";
import {UserPickerComponent} from "../../shared/user-picker/user-picker.component";

@Component({
  selector: 'app-change-owner-dialog',
  templateUrl: './change-owner-dialog.component.html',
  styleUrls: ['./change-owner-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    NgIf,
    UserPickerComponent
  ]
})
export class ChangeOwnerDialogComponent {

  selectedUser: User | null = null;

  constructor(public dialogRef: MatDialogRef<ChangeOwnerDialogComponent>) { }

  onUserSelected(user: User): void {
    this.selectedUser = user;
  }

  confirm(): void {
    if (this.selectedUser) {
      this.dialogRef.close(this.selectedUser);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
